import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Box, Text } from 'grommet';

const BackwardCounter = () => {
    let day = new Date('2019-07-01');
    const eventTime = moment(day);
    const duration = moment.duration(eventTime.diff(moment()))
    
    const initialState = {
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
    } 
    
    const [state, setState] = useState(initialState)

    const currentTime = () => {
        let day = new Date('2019-07-01');
        let eventTime = moment(day);
        let duration = moment.duration(eventTime.diff(moment()))
        setState ({
            days: duration.days(),
            hours: duration.hours(),
            minutes: duration.minutes(),
            seconds: duration.seconds(),
        })
    }

    useEffect(() => {
        const intervalId = setInterval(() => currentTime(), 1000)
        return () => {
           clearInterval(intervalId) 
        } // cleanup function
    }, []);

    const CounterContent = (props) => (
        <Text color='brand' size={props.size} weight='bold' >{props.children}</Text>
    )    
    
    return (
        <Box
            direction='column'
            margin={{ bottom: 'small', left: 'small', right: 'small', top: 'small'}}
        >
            <Box
                align='center' 
                direction='row'
                height='none'
            >
                <Box
                    align='center'
                    margin='xsmall' 
                >
                    <CounterContent size='large'>{state.days}</CounterContent> 
                    <CounterContent size='medium'>days</CounterContent> 
                </Box>
                <Box
                    align='center' 
                    margin='xsmall' 
                >
                    <CounterContent size='large'>{state.hours}</CounterContent> 
                    <CounterContent size='medium'>hours</CounterContent> 
                </Box>
                <Box
                    align='center' 
                    margin='xsmall' 
                >
                    <CounterContent size='large'>{state.minutes}</CounterContent> 
                    <CounterContent size='medium'>minutes</CounterContent> 
                </Box>
                <Box
                    align='center' 
                    margin='xsmall' 
                >
                    <CounterContent size='large'>{state.seconds}</CounterContent> 
                    <CounterContent size='medium'>seconds</CounterContent> 
                </Box>
            </Box>
        </Box>
    )

}

export default BackwardCounter